document.addEventListener('DOMContentLoaded', function() {
    const hamburgerMenu = document.getElementById('hamburger-menu');
    const mobileMenu = document.getElementById('mobile-menu');
    if (hamburgerMenu && mobileMenu) {
      hamburgerMenu.addEventListener('click', function() {
        mobileMenu.classList.toggle('open');
      });
    } else {
      console.error('Hamburger menu or mobile menu element not found.');
    }
  });

document.querySelectorAll('.accordion-toggle').forEach(button => {
  button.addEventListener('click', () => {
    const content = button.nextElementSibling;

    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', !isExpanded);
    content.classList.toggle('active');
  });
});




document.addEventListener("DOMContentLoaded", function () {
  const variantButtons = document.querySelectorAll(".variant-button");
  const priceSpan = document.querySelector('.btn-product-price');
  const productIdInput = document.querySelector('#selected-variant-id');

  if (variantButtons.length > 0 && priceSpan && productIdInput) {
    variantButtons.forEach(button => {
      button.addEventListener("click", function () {
        // Remove 'active' class from all buttons
        variantButtons.forEach(btn => btn.classList.remove("active"));

        // Add 'active' class to the clicked button
        this.classList.add("active");

        // Get variant ID and price
        const variantId = this.getAttribute("data-variant-id");
        const variantPrice = this.getAttribute("data-variant-price");

        // Update the price span text
        priceSpan.textContent = variantPrice;

        // Update the hidden input with the selected variant ID
        productIdInput.value = variantId;
      });
    });

    // Trigger the click event on the default selected variant
    document.querySelector(".variant-button.active")?.click();
  }
});






// $(document).ready(function () {
//   $('.mobile-toggle-arrow').click(function (e) {
//     e.preventDefault(); 
//     const submenu = $(this).closest('.mobile-child_link').find('.mobile-submenu');
//     submenu.slideToggle(); 
//     $(this).toggleClass('open');
//   });
// });

// document.addEventListener("DOMContentLoaded", function () {
//   const cartItems = document.querySelectorAll(".cart-item");
//   let hasSubscription = false;

//   cartItems.forEach(item => {
//     if (item.dataset.subscription === "true") { // Check if subscription exists
//       hasSubscription = true;
//     }
//   });

//   const checkoutButton = document.querySelector(".checkout-button");
//   const errorMessage = document.querySelector(".cart-error");

//   if (!hasSubscription) {
//     checkoutButton.disabled = true;
//     errorMessage.textContent = "You must have at least one subscription product in your cart to proceed to checkout.";
//   } else {
//     checkoutButton.disabled = false;
//     errorMessage.textContent = "";
//   }
// });

// document.addEventListener("DOMContentLoaded", function () {
//     document.querySelectorAll(".cart-btn").forEach(button => {
//         button.addEventListener("click", function (event) {
//             event.preventDefault(); // Prevent default behavior if it's a link
//             window.location.href = "https://www.saturee.com.au/cart";
//         });
//     });
// });

// document.addEventListener("DOMContentLoaded", function () {
//     document.querySelectorAll(".btn.btn--full.add-to-cart").forEach(button => {
//         button.addEventListener("click", function (event) {
//             event.preventDefault(); // Prevent default form submission
            
//             let form = button.closest("form"); // Find the closest form
//             let formData = new FormData(form);

//             fetch('/cart/add.js', {
//                 method: 'POST',
//                 body: formData
//             })
//             .then(response => response.json())
//             .then(data => {
//                 if (data.id) {
//                     showMessage("Product added to cart!", false);
//                 } else {
//                     showMessage("Failed to add product. Try again.", true);
//                 }
//             })
//             .catch(error => {
//                 console.error("Error adding product:", error);
//                 showMessage("Something went wrong. Try again later.", true);
//             });
//         });
//     });

//     function showMessage(message, isError = false) {
//         let messageDiv = document.createElement("div");
//         messageDiv.style.position = "fixed";
//         messageDiv.style.bottom = "20px";
//         messageDiv.style.right = "20px";
//         messageDiv.style.padding = "15px";
//         messageDiv.style.borderRadius = "5px";
//         messageDiv.style.color = "#fff";
//         messageDiv.style.backgroundColor = isError ? "red" : "green";
//         messageDiv.style.zIndex = "1000";
//         messageDiv.style.display = "flex";
//         messageDiv.style.alignItems = "center";
//         messageDiv.style.gap = "10px";
//         messageDiv.style.boxShadow = "0px 4px 6px rgba(0, 0, 0, 0.1)";

//         let messageText = document.createElement("span");
//         messageText.textContent = message;
//         messageDiv.appendChild(messageText);

//         if (!isError) {
//             let viewCartLink = document.createElement("a");
//             viewCartLink.href = "/cart";
//             viewCartLink.textContent = "View Cart";
//             viewCartLink.style.color = "#fff";
//             viewCartLink.style.textDecoration = "underline";
//             viewCartLink.style.fontWeight = "bold";
//             messageDiv.appendChild(viewCartLink);
//         }

//         document.body.appendChild(messageDiv);

//         setTimeout(() => {
//             messageDiv.remove();
//         }, 3000);
//     }
// });







